// Maps a notification's (notification_type, event_type, data) to a route this
// customer web app can actually navigate to. Only event_types whose "Who" is
// the customer are wired (booking/payment, plus the two customer-facing venue
// RFP events) — approval/change_request/review/proposal_requested/quotation_*
// (vendor decisions) event_types belong to vendor/admin clients per the
// notification doc and shouldn't reach a customer, but any unrecognized
// event_type still falls back safely (no navigation) instead of throwing.
const BOOKING_EVENT_TYPES = new Set([
    'booking_received',
    'booking_confirmed',
    'booking_cancelled',
    'booking_failed',
    'booking_refunded',
    'payment_successful',
    'payment_failed',
])

// Vendor declined the RFP, or sent a quotation — both shown on the same
// proposal-detail screen (`venueProposalDetail.jsx` reads `:id` as
// proposal_id via `endpoints.venues.proposalDetail`, and renders whatever
// quotation currently exists on that proposal). The doc's own data payload
// always includes `proposal_id` (the RFP id) for both event types, even
// though `entity_id` differs in meaning per `kind` — so `proposal_id` is the
// reliable field to route on, not `entity_id`.
const VENUE_CUSTOMER_EVENT_TYPES = new Set([
    'proposal_rejected',
    'quotation_received',
])

export const getNotificationRoute = (notification) => {
    const eventType = notification?.event_type
    const data = notification?.data || {}

    if (BOOKING_EVENT_TYPES.has(eventType) && data.booking_id) {
        const params = new URLSearchParams({ id: String(data.booking_id) })
        if (data.service) params.set('service', String(data.service))
        return `/trip-doc?${params.toString()}`
    }

    if (VENUE_CUSTOMER_EVENT_TYPES.has(eventType) && data.proposal_id) {
        return `/venue-proposal-detail/${data.proposal_id}`
    }

    return null
}
